import { money, type Money } from './money'

export interface MoneyFlow {
  inflow: Money
  outflow: Money
  net: Money
}

/** Yig'iladigan narsa yo'q yoki valyutalar har xil bo'lsa `null`: noto'g'ri jami umuman yo'qidan yomonroq. */
export function sumMoney(values: readonly Money[]): Money | null {
  return moneyFlow(values)?.net ?? null
}

/** Ishorali summalarni kirim (musbat), chiqim (manfiy) va ularning yig'indisiga ajratadi. */
export function moneyFlow(values: readonly Money[]): MoneyFlow | null {
  const currency = values[0]?.currency
  if (currency === undefined) return null
  let inflow = 0
  let outflow = 0
  for (const value of values) {
    if (value.currency !== currency) return null
    if (value.amount >= 0) inflow += value.amount
    else outflow += value.amount
  }
  return {
    inflow: money(inflow, currency),
    outflow: money(outflow, currency),
    net: money(inflow + outflow, currency),
  }
}
